import React, { useEffect, memo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setPageName } from '../../../../redux'
import CustomersCategoryTable from '../../../tabels/CustomersCategoryTable'
import { getData } from '../../../../assets/scripts/GeneralFunctions'
import SearchBox from './SearchBox'

function Categories() {
  const dispatch = useDispatch()
  const [customerTypes, setCustomerTypes] = useState([NaN, NaN])
  const [search, setSearch] = useState('')

  useEffect(() => {
    async function fetchData() {
      dispatch(setPageName('categories'))
      let api_result = await getData('admin/site-options/customer-types', 'get', {}, true)
      if (api_result) {
        if (api_result?.status === 200) {
          let result_data = api_result?.data
          setCustomerTypes(result_data?.customer_types)
        }
      }
    }

    fetchData()
  }, [])

  const searchResult = (search) => {
    setSearch(search)
  }

  return (
    <div>
      <div className="flex justify-between">
        <h1 className="text-xl font-medium my-auto dark:text-amber-50">لیست دسته بندی ها</h1>
        <div>
          <SearchBox
            customerTypes={customerTypes}
            setCustomerTypes={setCustomerTypes}
            searchResult={searchResult}
          />
        </div>
      </div>
      <div className={'md:py-8'}>
        <CustomersCategoryTable
          search={search}
          customerTypes={customerTypes}
          setCustomerTypes={setCustomerTypes}
        />
      </div>
    </div>
  )
}

export default memo(Categories)
